import { Injectable, signal } from '@angular/core';

/**
 * Which plan edit dialog is open. The dialogs render once, in the root layout, so they outlive the
 * view that opened them and sit above every page of the plan.
 */
@Injectable({ providedIn: 'root' })
export class PlanEditDialogsService {
  /** `save` lists the findings before a save and offers Save anyway. */
  readonly findings = signal<'save' | null>(null);
  readonly discard = signal(false);
}
